"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSystemTypeFilter = void 0;
var react_1 = require("react");
var ALL_TYPES_KEY = "__all__";
var buildSystemIdToType = function (schema) {
    if (!schema) {
        return {};
    }
    return schema.systems.reduce(function (accumulator, system) {
        if (system.id && system.type) {
            accumulator[system.id] = system.type;
        }
        return accumulator;
    }, {});
};
var countFieldsForType = function (schema, systemIdToType, type) {
    if (type === null) {
        return schema.fields.length;
    }
    return schema.fields.filter(function (field) {
        return field.mapping.some(function (mapping) { return mapping.system && systemIdToType[mapping.system] === type; });
    }).length;
};
/**
 * Encapsulates the "Filter by system type" dropdown state plus the derived
 * filtered field list.
 */
exports.useSystemTypeFilter = function (schema) {
    var _a = react_1.useState(null), selectedType = _a[0], setSelectedType = _a[1];
    var systemIdToType = react_1.useMemo(function () { return buildSystemIdToType(schema); }, [schema]);
    var filterOptions = react_1.useMemo(function () {
        if (!schema) {
            return [{ key: ALL_TYPES_KEY, text: "Filter by system type" }];
        }
        var uniqueTypes = Array.from(new Set(schema.systems
            .map(function (system) { return system.type; })
            .filter(function (type) { return Boolean(type); }))).sort();
        return __spreadArrays([
            {
                key: ALL_TYPES_KEY,
                text: "All system types (" + countFieldsForType(schema, systemIdToType, null) + ")",
            }
        ], uniqueTypes.map(function (type) { return ({
            key: type,
            text: type + " (" + countFieldsForType(schema, systemIdToType, type) + ")",
        }); }));
    }, [schema, systemIdToType]);
    var filteredFields = react_1.useMemo(function () {
        if (!schema) {
            return [];
        }
        if (!selectedType) {
            return schema.fields;
        }
        return schema.fields.filter(function (field) {
            return field.mapping.some(function (mapping) {
                return mapping.system && systemIdToType[mapping.system] === selectedType;
            });
        });
    }, [schema, selectedType, systemIdToType]);
    var setSelectedTypeFromKey = react_1.useCallback(function (next) {
        setSelectedType(next);
    }, []);
    return {
        selectedType: selectedType,
        setSelectedType: setSelectedTypeFromKey,
        filterOptions: filterOptions,
        selectedKey: selectedType || ALL_TYPES_KEY,
        filteredFields: filteredFields,
        ALL_TYPES_KEY: ALL_TYPES_KEY,
    };
};
